<ng-container *hasPermission="['SAFESTREET_ADMIN']">
    <div class="container-fluid">
        <div class="page-title">
            <h2>Dettaglio template default v2 - <b>{{detail_title}}</b></h2>
        </div>
        <form name="defaultReportTemplateV2Form" #f="ngForm" (ngSubmit)="onSubmit(f)">
            <div class="row">
                <div class="col-md-6">
                    <label for="name" class="form-label">Nome</label>
                    <input type="text" class="form-control" id="name" name="name"
                        [(ngModel)]="defaultReportTemplate.name" required />
                </div>
                <div class="col-md-6">
                    <label for="type" class="form-label">Tipologia</label>
                    <select class="form-select" aria-label="Tipo" id="type" name="type"
                        [(ngModel)]="defaultReportTemplate.type" [disabled]="type !== undefined" required>
                        <option selected value=""></option>
                        <option *ngFor="let reportTemplateType of reportTemplateTypes" [value]="reportTemplateType.id">
                            {{reportTemplateType.description}}</option>
                    </select>
                </div>
            </div>
            @if (!isHeaderType) {
            <div class="row">
                <div class="col-md-6">
                    <label for="customHeader" class="form-label">Personalizza intestazione</label>
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="customHeader" role="switch"
                            name="customHeader" [(ngModel)]="customHeader">
                    </div>
                </div>
            </div>
            }

            @if (!isHeaderType && customHeader) {
            <div class="row mt-2">
                <div class="col-12">
                    <label class="form-label">Intestazione</label>
                </div>
                <div class="col-12">
                    <app-report-editor name="headerHtml" [(ngModel)]="defaultReportTemplate.headerHtml"
                        [variables]="reportTemplateVariables" [required]="true" minHeight="150px"></app-report-editor>
                </div>
            </div>
            }
            @if (!isHeaderType && !customHeader) {
            <div class="row mt-2">
                <div class="col-12">
                    <div class="alert alert-secondary mb-0">Viene usata l'intestazione condivisa (template di tipo
                        Intestazione).</div>
                </div>
            </div>
            }

            <div class="row mt-2">
                <div class="col-12">
                    <label class="form-label">{{isHeaderType ? 'Intestazione condivisa' : 'Verbalino'}}</label>
                </div>
                <div class="col-12">
                    <app-report-editor name="innerHtml" [(ngModel)]="defaultReportTemplate.innerHtml"
                        [variables]="reportTemplateVariables" [required]="true"
                        minHeight="calc(100vh - 520px)"></app-report-editor>

                    <div class="d-flex justify-content-end align-items-center mt-2 gap-2">
                        <button type="button" class="btn btn-outline-secondary" (click)="back()">Indietro</button>
                        <button type="button" class="btn btn-primary" data-bs-toggle="modal"
                            data-bs-target="#preview72dv2" (click)="updatePreview()">Preview 72mm
                        </button>
                        <button type="button" class="btn btn-primary" data-bs-toggle="modal"
                            data-bs-target="#previewA4dv2" (click)="updatePreview()">Preview A4
                        </button>
                        <button type="submit" class="btn btn-primary">
                            Salva
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div class="modal fade" id="preview72dv2" tabindex="-1" aria-labelledby="preview72dv2Lbl" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="preview72dv2Lbl">Preview 72mm</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="small-printer-viewer" [innerHTML]="previewHTML"></div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal modal-xl fade" id="previewA4dv2" tabindex="-1" aria-labelledby="previewA4dv2Lbl"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="previewA4dv2Lbl">Preview A4</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="a4-printer-viewer" [innerHTML]="previewHTML"></div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
